import React, { useEffect, useRef, useState } from 'react'
import CircleLoader from '../../Loader/CircleLoader/CircleLoader';

import { RootState } from '../../../store';

import { useSelector } from 'react-redux';
import { IAoo, IUser } from '../../../shared/interfaces';
import abilityBuild from '../../../shared/CASL/appAbility';
import { useBoolean } from '@fluentui/react-hooks';
import usersService from '../../../services/users.service';
import { Selection, CheckboxVisibility, DetailsList, Icon, DetailsListLayoutMode, SelectionMode, Text, EventGroup, IRenderFunction, IDetailsHeaderProps, IDetailsListStyles, StickyPositionType, Sticky, IColumn, DetailsHeader, mergeStyleSets, ContextualMenu, IContextualMenuItem, ContextualMenuItemType } from '@fluentui/react';

const classNames = mergeStyleSets({
    emptyColumn: {

    },
});
export interface UsersAooManagerTableProps {
    forceTableRefresh?: boolean,
    readOnlyMode?: boolean,
    selectedUser?: IUser,
    userSelection: Selection,
    onSelectUsersAooManagerHandler?: (user: IUser | undefined) => void
    loadingUsersAooManagerTable?: boolean
    editUserAooManagerHandler?: () => void;
    deletetUserAooManagerHandler?: () => void;
}

type Props = UsersAooManagerTableProps;

const UsersAooManagerTable: React.FunctionComponent<Props> = (props) => {
    const selectCurrentAoo = (state: RootState) => state.sessionReducer.currentAoo;
    const currentAoo = useSelector(selectCurrentAoo);

    const selectIsMobile = (state: RootState) => state.sessionReducer.isMobile;
    const isMobile = useSelector(selectIsMobile);

    const [loadingUsersAooManagerTable, setLoadingUsersAooManagerTable] = useState<boolean>(false);

    const [tableColumns, setTableColumns] = useState<IColumn[] | undefined>([]);
    const [usersList, setUsersList] = useState<any[]>([]);

    const [showContextualMenu, setShowContextualMenu] = useState(false);
    const [contextMenuItems, setContextMenuItems] = useState<IContextualMenuItem[] | undefined>([]);
    const [contextMenuPosition, setContextMenuPosition] = useState<any>(undefined);


    useEffect(() => {
        setLoadingUsersAooManagerTable(props.loadingUsersAooManagerTable!);
    }, [props.loadingUsersAooManagerTable]);

    useEffect(() => {
        setColumns();
        getAllUsersAooManager();
    }, [currentAoo, props.forceTableRefresh]);

    useEffect(() => {
        const events = new EventGroup(undefined);
        events.on(props.userSelection, 'change', (ev) => {
            const selectedUser = props.userSelection.getSelection()[0] as IUser;
            if (props.onSelectUsersAooManagerHandler) {
                if (selectedUser) {
                    props.onSelectUsersAooManagerHandler(selectedUser);
                }
                else if (!selectedUser) {
                    props.onSelectUsersAooManagerHandler(undefined);
                }
            }
        });

        return () => {
            // Anything in here is fired on component unmount.
            events.dispose();
        }

    }, [usersList]);


    useEffect(() => {

    }, [props.selectedUser]);

    const getAllUsersAooManager = () => {
        if (currentAoo) {
            setLoadingUsersAooManagerTable(true);
            setUsersList([]);

            let getUsersAooManager;
            getUsersAooManager = usersService.getAllUsersInSelectedAoo(currentAoo.id);

            getUsersAooManager
                .then(usersList => {
                    setLoadingUsersAooManagerTable(false);
                    setUsersList(usersList);
                })
                .catch(error => {
                    setLoadingUsersAooManagerTable(false);
                    setUsersList([]);
                });
        }
    }

    const setColumns = () => {
        const fieldColumns = [

            {
                key: 'displayName',
                fieldName: 'displayName',
                name: 'Nome utente',
                minWidth: 100,
                maxWidth: 200,
                isResizable: true,
            },
            {
                key: 'isSuperAdmin',
                fieldName: 'isSuperAdmin',
                name: 'SuperAdmin',
                minWidth: 100,
                maxWidth: 150,
                isResizable: true,
            },
            {
                key: 'admin',
                fieldName: 'admin',
                name: 'Admin',
                minWidth: 100,
                maxWidth: 150,
                isResizable: true,
            },
            {
                key: 'supervisore',
                fieldName: 'supervisore',
                name: 'Supervisore',
                minWidth: 100,
                maxWidth: 150,
                isResizable: true,
            },
            {
                key: 'defaultAoo',
                fieldName: 'defaultAoo',
                name: 'Default Aoo',
                minWidth: 100,
                maxWidth: 150,
                isResizable: true,
            },
            {
                key: 'emailNotifica',
                fieldName: 'emailNotifica',
                name: 'Email di Notifica',
                minWidth: 100,
                isResizable: true,
            },


            //{
            //    key: 'notificaGiornaliera',
            //    fieldName: 'notificaGiornaliera',
            //    name: 'Notifica Giornaliera',
            //    minWidth: 100,
            //    maxWidth: 200,
            //    isResizable: true,
            //},
        ];
        /// Aggiungo una colonna vuota in coda alla tabella, è necessaria per consentire l'allineamneto tra
        /// l'header e i contenuti della tabella 
        if (isMobile == false) {
            fieldColumns.push(
                {
                    key: 'empty',
                    name: '',
                    fieldName: 'empty',
                    minWidth: 1,
                    maxWidth: 1,
                    isResizable: false
                },

            );
        }

        setTableColumns([...fieldColumns]);
    }


    const onRenderDetailsHeader = (detailsHeaderProps) => {
        const detailsListHeadrerStyles: Partial<IDetailsListStyles> = {

            root: { boxSizing: 'content-box !important' }

        };
        return (
            <DetailsHeader
                {...detailsHeaderProps}
                styles={detailsListHeadrerStyles}
            />
        );
    }

    const onRenderItemColumn = (item?: IUser, index?: number | undefined, column?) => {
        if (item) {
            const fieldContent = item[column.fieldName];
            switch (column.fieldName) {
                case 'isSuperAdmin':
                    if (item!.isSuperAdmin) {
                        return <span><Icon iconName={"CheckMark"} style={{ color: 'green', fontSize: '15px', fontWeight: 'bold' }} /></span>
                    }
                    else {
                        return <span></span>
                    }
                case 'admin':
                    if (usersService.userIsAdmin(item!, currentAoo!.id)) {
                        return <span><Icon iconName={"CheckMark"} style={{ color: 'green', fontSize: '15px', fontWeight: 'bold' }} /></span>
                    }
                    else {
                        return <span></span>
                    }
                case 'supervisore':
                    if (usersService.userIsSupervisore(item!, currentAoo!.id)) {
                        return <span><Icon iconName={"CheckMark"} style={{ color: 'green', fontSize: '15px', fontWeight: 'bold' }} /></span>
                    }
                    else {
                        return <span></span>
                    }
                case 'notificaGiornaliera':
                    const notificaGiornaliera = fieldContent;
                    if (notificaGiornaliera) {
                        return <span><Icon iconName={"CheckMark"} style={{ color: 'green', fontSize: '15px', fontWeight: 'bold' }} /></span>
                    }
                    else {
                        return <span></span>
                    }
                case 'defaultAoo':
                    const defaultAoo = (fieldContent as IAoo);
                    if (defaultAoo) {
                        return <span>{defaultAoo.name}</span>
                    } else {
                        return <span></span>
                    }
                default:
                    return <span>{fieldContent}</span>;
            }
        }
    }

    // metodi gestione context menu 
    const onShowContextualMenu = (item, index, ev) => {
        ev.preventDefault();

        updateContextMenuUsersAooManager();
        setShowContextualMenu(true);
        setContextMenuPosition(ev);

    };

    const updateContextMenuUsersAooManager = () => {
        const menuItems: IContextualMenuItem[] = [];

        if (abilityBuild.can('update', 'IUser')) {
            menuItems.push(
                {
                    key: 'editUser',
                    text: 'Modifica utente',
                    iconProps: { iconName: 'EditContact' },
                    onClick: () => {
                        props.editUserAooManagerHandler!();
                        onHideContextualMenu();
                    }
                }
            )
        }
        setContextMenuItems(menuItems);
    }

    const onHideContextualMenu = () => {
        setShowContextualMenu(false);
        setContextMenuItems(undefined);
    };

    return (
        <React.Fragment>
            <CircleLoader loaderClass='loader-large' loading={loadingUsersAooManagerTable} />

            {/* <div className={`my-component-content`}>*/}

            {
                usersList && usersList.length > 0
                    ? <DetailsList
                        className="with-empty-column"
                        items={usersList}
                        columns={tableColumns}
                        layoutMode={DetailsListLayoutMode.justified}
                        onRenderDetailsHeader={onRenderDetailsHeader}
                        onRenderItemColumn={onRenderItemColumn}
                        selection={props.userSelection}
                        selectionPreservedOnEmptyClick={true}
                        selectionMode={SelectionMode.single}
                        checkboxVisibility={CheckboxVisibility.onHover}
                        onItemContextMenu={onShowContextualMenu}
                    />
                    : <div style={{ marginLeft: '31px' }}>
                        <Text> Nessun utente inserito</Text>
                    </div>
            }

            <ContextualMenu
                items={contextMenuItems!}
                hidden={!showContextualMenu}
                target={contextMenuPosition}
                onItemClick={onHideContextualMenu}
                onDismiss={onHideContextualMenu}
            />

            {/*  </div>*/}

        </React.Fragment>
    )
}
export default UsersAooManagerTable;
